(ns app.components.workspace-item.views
  (:require
   [re-frame.core :as re-frame]
   [app.components.workspace-item.styles :refer [selected-divider selected-workspace-item workspace-item new-workspace-item workspace-tooltip]]
   [app.events :as events]
   [re-com.core :as re-com :refer [at]]
   [reagent-mui.material.tooltip :refer [tooltip]]))

(defn workspace_btn [{:keys [name selected onClick logo]}]
  [re-com/h-box
   :src at
   :gap      "6px"
   :style {:display "flex"}
   :children [[re-com/line
               :size  "4px"
               :color (if (= selected true) "#5555F2" "transparent")
               :class  (selected-divider)]
              [tooltip
               {:title name
                :placement "right"
                :arrow true
                :classes {:popper (workspace-tooltip)}}
               [:div [re-com/button
                      :src at
                      :label (if (some? logo) [:img {:src logo :width "100%" :height "100%" :style {:border-radius "4px"}}] (get name 0))
                      :style {:padding (when (some? logo) "0px")
                              :background-color (when (some? logo) "transparent")}
                      :class  (if (= selected true) (selected-workspace-item) (workspace-item))
                      :on-click onClick]]]]])

(defn new_workspace [{:keys [onClick]}]
  [re-com/h-box
   :src at
   :gap      "6px"
   :style {:display "flex"}
   :children [[re-com/line
               :size  "4px"
               :color "transparent"]
              [re-com/button
               :label "+"
               :class   (new-workspace-item)
               :on-click onClick]]])